import React from 'react';
import { Typography, Box, Container, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import logo from "assets/img/boxlogo.png";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  logo: {
    display:'flex',
    justifyContent:'center', /* horizontally center */
    alignItems:'center',    /* vertically center */
    height:'120px',
    width: '100%',
    marginBottom: theme.spacing(5),
  },
  img: {
    maxWidth:'100%',
    maxHeight:'100%'
  }
}));

export default function PrivacyPolicy() {
  const classes = useStyles();

  return (
    <Container component="main" className={classes.container} maxWidth="md">
        <div className={classes.logo}>
            <img src={logo} alt="logo" className={classes.img}/>
        </div>
      
        <Typography variant="h4" component="h1" gutterBottom>
        Política de Privacidade do Aplicativo Box Idiomas
      </Typography>
      
      <Box className={classes.section}>
        <Typography>
          Bem-vindo ao Box Idiomas. Esta Política de Privacidade descreve como lidamos com informações que podem ser coletadas durante o uso do aplicativo exclusivo para alunos da nossa escola de inglês.
        </Typography>
      </Box>
      
      <Box className={classes.section}>
        <Typography variant="h5" component="h2" gutterBottom>
          1. Informações Coletadas
        </Typography>
        <Typography>
          Nosso aplicativo não coleta dados pessoais e sensíveis dos usuários. Os dados de acesso dos estudantes são previamente cadastrados pela escola e são utilizados apenas para permitir o acesso ao conteúdo do aplicativo.
        </Typography>
      </Box>
      
      <Box className={classes.section}>
        <Typography variant="h5" component="h2" gutterBottom>
          2. Uso das Informações
        </Typography>
        <Typography>
          As informações fornecidas pelo usuário ao se cadastrar no aplicativo são usadas exclusivamente para:
        </Typography>
        <ul>
          <li>Permitir o acesso aos materiais de aula, como apostilas e atividades.</li>
          <li>Oferecer funcionalidades como tradução simultânea e outras ferramentas de aprendizado.</li>
        </ul>
      </Box>
      
      <Box className={classes.section}>
        <Typography variant="h5" component="h2" gutterBottom>
          3. Compartilhamento de Informações
        </Typography>
        <Typography>
          Não compartilhamos informações dos usuários com terceiros. Todas as informações são mantidas exclusivamente para o uso interno da escola e para a funcionalidade do aplicativo.
        </Typography>
      </Box>
      
      <Box className={classes.section}>
        <Typography variant="h5" component="h2" gutterBottom>
          4. Retenção e Exclusão de Dados
        </Typography>
        <Typography>
          Os dados de acesso dos usuários são mantidos enquanto o aluno estiver matriculado na escola. Quando o aluno deixar de ser estudante da escola, seus dados de acesso serão excluídos do sistema.
        </Typography>
      </Box>
      
      <Box className={classes.section}>
        <Typography variant="h5" component="h2" gutterBottom>
          5. Segurança dos Dados
        </Typography>
        <Typography>
          Tomamos medidas apropriadas para proteger os dados de acesso dos estudantes contra perda, uso indevido, acesso não autorizado, divulgação, alteração e destruição. No entanto, é importante lembrar que nenhum método de transmissão pela internet ou de armazenamento eletrônico é 100% seguro.
        </Typography>
      </Box>
      
      <Box className={classes.section}>
        <Typography variant="h5" component="h2" gutterBottom>
          6. Alterações nesta Política de Privacidade
        </Typography>
        <Typography>
          Podemos atualizar nossa Política de Privacidade de tempos em tempos. Notificaremos os usuários sobre quaisquer alterações publicando a nova Política de Privacidade nesta página. Recomenda-se revisar periodicamente esta Política de Privacidade para estar ciente de quaisquer modificações.
        </Typography>
      </Box>
      
      <Box className={classes.section}>
        <Typography variant="h5" component="h2" gutterBottom>
          7. Contato
        </Typography>
        <Typography>
          Se você tiver qualquer dúvida ou preocupação sobre esta Política de Privacidade, entre em contato conosco:
        </Typography>
        <ul>
          <li>Nome do Desenvolvedor/Empresa: Box Idiomas</li>
          <li>E-mail de contato: <Link href="mailto:boxidiomas123@gmail.com">boxidiomas123@gmail.com</Link></li>
        </ul>
      </Box>
      
      <Box className={classes.section}>
        <Typography variant="h5" component="h2" gutterBottom>
          8. Aceitação desta Política
        </Typography>
        <Typography>
          Ao usar nosso aplicativo, você concorda com a coleta e uso das informações conforme descrito nesta Política de Privacidade.
        </Typography>
      </Box>
      
      <Box className={classes.section}>
        <Typography>
          Esta Política de Privacidade é vigente a partir de Junho de 2024.
        </Typography>
      </Box>
    </Container>
  );
}
